export default function LoginForm({
    email,
    password,
    onEmailChange,
    onPasswordChange,
    onSubmit,
    error,
    success,
    onShowSignup,
    onShowForgotPassword,
    googleClientId
}) {
    return (
        <>
            <h1>Sign in</h1>
            <p className="auth-subtitle">Sign in to rule your world</p>

            <form onSubmit={onSubmit} className="auth-form">
                <input type="email" className="input-field" placeholder="you@company.com" value={email} onChange={e => onEmailChange(e.target.value)} autoFocus required />
                <input type="password" className="input-field" placeholder="Password" value={password} onChange={e => onPasswordChange(e.target.value)} required />
                <div className="auth-forgot-row">
                    <button type="button" className="auth-link" onClick={onShowForgotPassword}>Forgot password?</button>
                </div>

                {error && <div className="auth-error"><i className="fa-solid fa-triangle-exclamation"></i>{error}</div>}
                {success && <div className="auth-success">{success}</div>}

                <button type="submit" className="btn-primary auth-submit">Continue</button>
            </form>

            {googleClientId && (
                <>
                    <div className="auth-divider"><span>OR</span></div>
                    <div className="auth-sso">
                        <div id="google-signin-btn"></div>
                    </div>
                </>
            )}

            <p className="auth-switch">
                Don&apos;t have an account?{' '}
                <button type="button" className="auth-link" onClick={onShowSignup}>Create account</button>
            </p>
        </>
    );
}
